import { booleanAttribute, Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[talyHoverTooltip]',
  standalone: false,
  host: {
    class: 'taly-hover-tooltip',
    '[attr.data-full-name]': 'tooltipText',
    '[class.taly-hover-tooltip--active]': 'tooltipText !== null',
    '[class.taly-hover-tooltip--rtl]': 'talyHoverTooltipRtl',
    '[class.taly-hover-tooltip--flex-cell]': 'talyHoverTooltipFlexCell',
  },
})
export class HoverTooltipDirective {
  /** Tooltip text; trimmed. No bubble when empty after trim. */
  @Input() talyHoverTooltip: string | null | undefined;

  @Input() talyHoverTooltipRtl = false;

  @Input({ transform: booleanAttribute }) talyHoverTooltipFlexCell = false;

  /** True while a touch is active on the host (iOS often skips CSS :active on non-links). */
  @HostBinding('class.taly-hover-tooltip--touch-pressed')
  touchPressed = false;

  @HostListener('touchstart')
  onTouchStart(): void {
    if (this.tooltipText === null) {
      return;
    }
    this.touchPressed = true;
  }

  @HostListener('touchend')
  @HostListener('touchcancel')
  onTouchEnd(): void {
    this.touchPressed = false;
  }

  get tooltipText(): string | null {
    const t = this.talyHoverTooltip;
    if (t == null || typeof t !== 'string') {
      return null;
    }
    const s = t.trim();
    return s || null;
  }
}
